import { createClient } from '@/shared/api';
import type {
  UpdateStudyPatientInsuranceMutation,
  UpdateStudyPatientInsuranceMutationVariables,
} from '@/shared/api';
import UPDATE_STUDY_PATIENT_INSURANCE from '../mutations/updateStudyPatientInsurance';

/**
 * Saves the patient's insurance details on a study. Runs UPDATE_STUDY_PATIENT_INSURANCE and throws the returned message when isSuccess is false.
 *
 * @param input - Mutation input payload.
 * @returns The updateStudyPatientInsurance payload.
 */
const handleUpdateStudyPatientInsurance = async (
  input: UpdateStudyPatientInsuranceMutationVariables['input'],
): Promise<UpdateStudyPatientInsuranceMutation['updateStudyPatientInsurance']> => {
  const client = createClient();
  const result = await client.mutate<
    UpdateStudyPatientInsuranceMutation,
    UpdateStudyPatientInsuranceMutationVariables
  >({
    mutation: UPDATE_STUDY_PATIENT_INSURANCE,
    variables: { input },
  });
  const { data } = result;
  const { updateStudyPatientInsurance } = data ?? {};
  if (!updateStudyPatientInsurance?.isSuccess) {
    throw new Error(updateStudyPatientInsurance?.message ?? undefined);
  }
  return updateStudyPatientInsurance;
};

export default handleUpdateStudyPatientInsurance;
